import { STACKS_COLUMN_ID } from "../constants";
import StacksTableIssuesCell from "./IssuesCell";
import StacksTableSettingsCell from "./SettingsCell";
import StacksTableNameCell from "./NameCell";
import StacksTableRowActionsCell from "./RowActionsCell";
import StacksTableStateCell from "./StateCell";
import StacksTableFavoriteCell from "./FavoriteCell";
import StacksTableLabelsCell from "./LabelsCell";
import StacksTableSpaceCell from "./SpaceCell";
import StacksTableVendorCell from "./VendorCell";
import StacksTableBranchCell from "./BranchCell";
import StacksTableCommitCell from "./CommitCell";
import StacksTableRepositoryCell from "./RepositoryCell";
import StacksTableGitTagCell from "./GitTagCell";
import StacksTableProjectRootCell from "./ProjectRootCell";
import StacksTableDeltaCell from "./DeltaCell";
import StacksTableUpdatedAtCell from "./UpdatedAtCell";
import StacksTableLastApplyAttemptCell from "./LastApplyAttemptCell";
import StacksTableDescriptionCell from "./DescriptionCell";
import StacksTableBlueprintCell from "./BlueprintCell";

export const STACKS_TABLE_CELLS = {
  [STACKS_COLUMN_ID.NAME]: StacksTableNameCell,
  [STACKS_COLUMN_ID.STATE]: StacksTableStateCell,
  [STACKS_COLUMN_ID.ISSUES]: StacksTableIssuesCell,
  [STACKS_COLUMN_ID.SETTINGS]: StacksTableSettingsCell,
  [STACKS_COLUMN_ID.FAVORITE]: StacksTableFavoriteCell,
  [STACKS_COLUMN_ID.LABELS]: StacksTableLabelsCell,
  [STACKS_COLUMN_ID.SPACE]: StacksTableSpaceCell,
  [STACKS_COLUMN_ID.VENDOR]: StacksTableVendorCell,
  [STACKS_COLUMN_ID.BRANCH]: StacksTableBranchCell,
  [STACKS_COLUMN_ID.COMMIT]: StacksTableCommitCell,
  [STACKS_COLUMN_ID.REPOSITORY]: StacksTableRepositoryCell,
  [STACKS_COLUMN_ID.GIT_TAG]: StacksTableGitTagCell,
  [STACKS_COLUMN_ID.PROJECT_ROOT]: StacksTableProjectRootCell,
  [STACKS_COLUMN_ID.DELTA_COUNTS]: StacksTableDeltaCell,
  [STACKS_COLUMN_ID.UPDATED_AT]: StacksTableUpdatedAtCell,
  [STACKS_COLUMN_ID.LAST_APPLY_ATTEMPT]: StacksTableLastApplyAttemptCell,
  [STACKS_COLUMN_ID.DESCRIPTION]: StacksTableDescriptionCell,
  [STACKS_COLUMN_ID.BLUEPRINT]: StacksTableBlueprintCell,
  [STACKS_COLUMN_ID.ROW_ACTIONS]: StacksTableRowActionsCell,
};
